import React from 'react';
let FaInfo = require('react-icons/lib/fa/info');
let FaTimes = require('react-icons/lib/fa/close');

const HelpIcon = React.createClass({
    propTypes: {
        onClick: React.PropTypes.func
    },

    getInitialState: function() {
        return {
            active: false
        };
    },

    handleClick: function(){
        this.props.onClick();
        this.setState({
            active: (this.state.active) ? false: true
        });
    },

    render() {
        return (
            <div onClick={this.handleClick} className={this.state.active ? "help-icon active" : "help-icon"}>
                <FaInfo className="inactive-icon" />
                <FaTimes className="active-icon" />
            </div>
        );
    }
});

export default HelpIcon;


/** WEBPACK FOOTER **
 ** ./src/components/Fields/HelpIcon.js
 **/